import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { IDocumentSummaryInfo } from '../../../message-models/document-summary-info.interface';
import { DocumentEntityType, DocumentEntityTypeString } from '../../../message-models/document-entity-type.enum';
import { MenuItem } from 'primeng/api';

@Component({
  selector: 'app-companies-documents-lists',
  templateUrl: './companies-documents-list.component.html',
  styleUrls: ['./companies-documents-list.component.scss']
})
export class CompaniesDocumentsListComponent implements OnInit {
  documentEntityType = DocumentEntityType;
  documentEntityTypeString: typeof DocumentEntityTypeString = DocumentEntityTypeString;
  @Input() showTableCaption: boolean;
  @Input() documentSummaryInfos: Array<IDocumentSummaryInfo>;
  @Input() allowEdit: boolean = true;
  @Input() allowDelete: boolean = true;

  @Output() openCompanyDocument: EventEmitter<IDocumentSummaryInfo> = new EventEmitter<IDocumentSummaryInfo>();
  @Output() editCompanyDocument: EventEmitter<IDocumentSummaryInfo> = new EventEmitter<IDocumentSummaryInfo>();
  @Output() downloadCompanyDocument: EventEmitter<IDocumentSummaryInfo> = new EventEmitter<IDocumentSummaryInfo>();
  @Output() deleteCompanyDocumentClick: EventEmitter<IDocumentSummaryInfo> = new EventEmitter<IDocumentSummaryInfo>();
  @Output() refreshDocumentsRequested: EventEmitter<boolean> = new EventEmitter<boolean>();
  expiredFilter = { includeExpired: false };
  columns: any[];
  rowMenuItems: MenuItem[];


  constructor(private router: Router) {
  }


  isOnMobile = false;
  ngOnInit(): void {
    this.isOnMobile = window.outerWidth <= 480;
    this.columns = [
      { field: 'companyName', header: 'Owner', type: 'owner' },
      { field: 'entityType', header: 'Type', type: 'type' },
      { field: 'documentType', header: 'Document Type', type: 'text' },
      { field: 'originalFilename', header: 'Original Filename', type: 'text' },
      { field: 'documentCreationDate', header: 'Created On', type: 'date' },
      { field: 'expiryDate', header: 'Expires On', type: 'date' },
      { field: 'reviewDate', header: 'Review Due On', type: 'date' },
      { field: 'totalObservations', header: 'Num. Obs.', type: 'int' },
    ];

    this.rowMenuItems = [
      {
        label: 'Preview',
        icon: 'fas fa-search',
        state: { 'contextLogic': 'canPreviewDocument' },
        styleClass: 'eca-menu-item-green',
        command: ($event) => this.openDocument($event)
      },
      {
        label: 'Edit',
        icon: 'fas fa-edit',
        styleClass: 'eca-menu-item-green',
        visible: this.allowEdit,
        command: ($event) => this.editDocument($event)
      },
      {
        label: 'Download',
        icon: 'fas fa-download',
        styleClass: 'eca-menu-item-green',
        command: ($event) => this.downloadDocument($event)
      },
      {
        label: 'Remove',
        icon: 'fas fa-trash-alt',
        visible: this.allowDelete,
        styleClass: 'eca-menu-item-red',
        command: ($event) => this.deleteCompanyDocument($event)
      }
    ]
  }

  openDocument(documentSummaryInfo: IDocumentSummaryInfo) {
    this.openCompanyDocument.emit(documentSummaryInfo);
  }

  deleteCompanyDocument(documentSummaryInfo: any) {
    this.deleteCompanyDocumentClick.emit(documentSummaryInfo);
  }

  downloadDocument(documentSummaryInfo: any) {
    this.downloadCompanyDocument.emit(documentSummaryInfo);

  }

  editDocument(documentSummaryInfo: any) {
    this.editCompanyDocument.emit(documentSummaryInfo);
  }

  viewCompanyDocumentClicked(documentSummaryInfo: IDocumentSummaryInfo) {
    if (documentSummaryInfo.entityType === DocumentEntityType.company) {
      this.router.navigate(['/company-document/', documentSummaryInfo.documentId]);
    }
    else if (documentSummaryInfo.entityType === DocumentEntityType.employedPerson) {
      this.router.navigate(['/operative-document/', documentSummaryInfo.documentId]);
    }
    else if (documentSummaryInfo.entityType === DocumentEntityType.trainingRecord) {
      this.router.navigate(['/training-record-document/', documentSummaryInfo.documentId]);
    }
    else if (documentSummaryInfo.entityType === DocumentEntityType.trainingCourse) {
      this.router.navigate(['/training-course-document/', documentSummaryInfo.documentId]);
    }
  }

  expiredFilterChanged() {
    this.refreshDocumentsRequested.emit(this.expiredFilter.includeExpired);

  }
}
